import { render, staticRenderFns } from "./Page-Stock.vue?vue&type=template&id=21c68beb"
import script from "./Page-Stock.vue?vue&type=script&lang=js"
export * from "./Page-Stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports